// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from '../../utils/axios';
import utils from '../../utils/utils';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const PATH = '/exercises-equipments';

const initialState = {
    byExercise: [],
    byExerciseIds: [],
    byExerciseObject: {},
    byEquipment: {},
    byEquipmentIds: [],
    byEquipmentObject: {},
    error: null,
    totalPages: 1,
    loading: false,
    limit: 10,
    currentPage: 1
};

// Reducer
const slice = createSlice({
    name: 'exeq',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },

        startLoading(state, action) {
            state.loading = true;
        },
        stopLoading(state, action) {
            state.loading = false;
        },

        // GET USERS STYLE 1

        getEqSuccess(state, action) {
            state.byEquipmentIds = action.payload?.map((item) => item?.SK?.replace('equipment-', ''));
            state.byEquipmentObject = utils.getUniqueObject(action.payload, 'SK');
        },

        getExSuccess(state, action) {
            state.byExerciseIds = action.payload?.map((item) => item?.PK?.replace('exercise-', ''));
            state.byExerciseObject = utils.getUniqueObject(action.payload, 'PK');
        },

        addSuccess(state, action) {
            state.loading = false;
        },

        setCurrentPage(state, action) {
            console.log(action.payload);
            state.currentPage = action.payload;
        }
    }
});

export default slice.reducer;

// Actions

export function startLoading() {
    return async () => {
        dispatch(slice.actions.startLoading());
    };
}

export function stopLoading() {
    return async () => {
        dispatch(slice.actions.stopLoading());
    };
}

// Passing equipment id and get all exercise in that equipment
export function getByExercise(equipmentId = '') {
    return async () => {
        try {
            const result = await axios.get(`/exercises/equipments/${equipmentId}`);
            console.log('RES [getByExercise]:', result.data.data);
            dispatch(slice.actions.getExSuccess(result.data.data));
        } catch (error) {
            console.log('ERR [getByExercise]:', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

// Passing exercise id and get all equipment in that exercise
export function getByEquipment(exerciseId = '') {
    return async () => {
        try {
            const result = await axios.get(`${BASE_URL}/${PATH}/by-exercise?exerciseId=${exerciseId}`);
            console.log('RES [getByEquipment]:', result.data.data, exerciseId);
            dispatch(slice.actions.getEqSuccess(result.data.data));
        } catch (error) {
            console.log('ERR [getByEquipment]:', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addEqEx(exerciseId = '', equipmentId = '') {
    return async () => {
        try {
            const result = await axios.post(`${BASE_URL}/${PATH}?exerciseId=${exerciseId}&equipmentId=${equipmentId}`);
            console.log('RES [addEqEx] ======> ', result.data.data);
            dispatch(slice.actions.addSuccess(result.data.data));
        } catch (error) {
            console.log('ERR [addEqEx] =======> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteEqEx(PK = '', SK = '', callback = () => {}) {
    return async () => {
        try {
            const result = await axios.delete(`${BASE_URL}/${PATH}?PK=${PK}&SK=${SK}`);
            if (result.data.data) {
                callback();
            }
            console.log('RES [deleteEqEx] ======> ', result.data.data);
        } catch (error) {
            console.log('ERR [deleteEqEx] =======> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function setCurrentPage(page) {
    return async () => {
        dispatch(slice.actions.setCurrentPage(page));
    };
}
